var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIBotNav04On(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.642 20.4175C19.4816 19.5662 18.9018 18.8568 18.0999 18.5237L15.1821 17.3147C14.7874 17.1543 14.5344 16.7657 14.5344 16.34V15.2729C14.5344 14.9089 14.701 14.5635 14.9971 14.3476C15.9717 13.6444 16.5886 12.6081 16.8291 11.399C17.5755 11.3127 18.1554 10.6897 18.1554 9.91859V9.51147C18.1554 8.83293 17.6989 8.26543 17.082 8.08037L17.1191 7.47585C17.1252 4.76169 15.0711 2.37447 12.3446 2.20175C9.35904 2.00436 6.87928 4.37308 6.87928 7.31547L6.92863 8.09271C6.30561 8.27159 5.84914 8.84527 5.84914 9.52381V9.93093C5.84914 10.702 6.42898 11.325 7.17537 11.4114C7.41595 12.6142 8.0328 13.6567 9.00743 14.3599C9.30352 14.5758 9.47007 14.9213 9.47007 15.2852V16.3524C9.47007 16.778 9.21099 17.1605 8.82237 17.327L5.90465 18.536C5.10274 18.8691 4.52907 19.5785 4.36252 20.4298L4.20831 21.2379C4.15279 21.5401 4.38102 21.8115 4.68328 21.8115H19.3151C19.6173 21.8115 19.8517 21.534 19.79 21.2379L19.6358 20.4175H19.642Z",
    fill: "#10141A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIBotNav04On);
export default __webpack_public_path__ + "static/media/i_bot_nav_04_on.b3ed88b151c8ee17c94d56c308f40e64.svg";
export { ForwardRef as ReactComponent };